import React from "react";
import { Link } from "react-router-dom";

import { NameEntityResponse } from "../../../api-models/response/NameEntityResponse";
import FormField from "../../../components/form-field/FormField";

export function DisplaySewerObjectId(props: any) {
  return (
    <FormField
      id="sewer-object-external-id"
      labelKey={props.labelKey}
      readOnly
      fieldValue={props.id}
    />
  );
}

export function DisplayDataOwner(props: any) {
  return (
    <FormField
      id="data-owner"
      labelKey="sewer-objects.DisplayDataOwner.label"
      readOnly
      fieldValue={props.dataOwner}
    />
  );
}

interface InProjectProps {
  project: NameEntityResponse;
  enableRedirect?: boolean;
}

export function DisplayInProject(props: InProjectProps) {
  return (
    <FormField
      id="section-project-name"
      labelKey="general.in-project"
      readOnly
      fieldValue={
        props.enableRedirect ? (
          <Link to={`/projects/${props.project.id}`}>{props.project.name}</Link>
        ) : (
          props.project.name
        )
      }
    ></FormField>
  );
}

export function DisplayOpenJobs(props: any) {
  return (
    <FormField
      id="section-project-name"
      labelKey="sewer-objects.DisplayOpenJobs.label"
      readOnly
      fieldValue={props.openJobs}
    />
  );
}
